<template>
    <div id="ptoContent">
        <b-alert :show="errorMsg.length" variant="danger">{{ errorMsg }}</b-alert>

        <b-row>
            <b-col>
                <h6>{{ available }} Available</h6>

                <div v-if="available > 0">
                    <b-form-datepicker v-model="use.date" :state="use.date !== null"></b-form-datepicker>
                    <b-button-group>
                        <b-input placeholder="Reason" v-model="use.reason"></b-input>
                        <b-button size="sm" @click="useDay" :disabled="!use.date">Use</b-button>
                    </b-button-group>
                </div>
            </b-col>

            <b-col>
                <h6>{{ used }} Used</h6>

                <b-list-group>
                    <b-list-group-item v-for="day in days" :key="day._id">
                        <h6>{{ moment(day.date).format('M/D/YYYY') }}</h6>
                        <small><em>{{ day.reason }}</em></small>
                    </b-list-group-item>
                </b-list-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import timecardApi from "@/api/timecard";

    export default {
        name: "PaidTimeOff",
        mixins: [ timecardApi ],
        data() {
            return {
                available: 0,
                used: 0,
                use: {
                    date: null,
                    reason: '',
                },
                days: [],
                errorMsg: '',
            }
        },
        created() {
            this.getPto();
            this.getPtoLog();
        },
        methods: {
            async getPto() {
                try {
                    let data = await this.getPaidTimeOff();

                    if (data) {
                        this.available = data.available;
                        this.used = data.used;
                    }
                } catch (err) {
                    this.errorMsg = err.response.data.message;
                }
            },
            async getPtoLog() {
                try {
                    this.days = await this.getPaidTimeOffLog();
                } catch (err) {
                    this.errorMsg = err.response.data.message;
                }
            },
            async useDay() {
                try {
                    await this.usePaidTimeOff(this.use.date, this.use.reason);

                    this.use.date = null;
                    this.use.reason = '';

                    await this.getPto();
                    await this.getPtoLog();
                } catch (err) {
                    this.errorMsg = err.response.data.message;
                }
            }
        }
    }
</script>

<style scoped>
    #ptoContent {
        min-height: 450px;
    }
</style>